import useAppName from './useAppName';
import { Organization, OrganizationName } from 'constants/organization/types';
import { organizations } from 'constants/organization/organizations';

export const useAppDetails = (): Organization => {
    const appName = useAppName();
    const appDetails = appName ? organizations[appName] : organizations[OrganizationName.YUBI];
    return appDetails;
};
